import { isEmpty, isNil, or } from 'ramda';

export const isBlank = value => or(isEmpty(value), isNil(value));